import { useTreeViewItems } from "../internals/plugins/useTreeViewItems/index.js";
import { useTreeViewExpansion } from "../internals/plugins/useTreeViewExpansion/index.js";
import { useTreeViewSelection } from "../internals/plugins/useTreeViewSelection/index.js";
import { useTreeViewFocus } from "../internals/plugins/useTreeViewFocus/index.js";
import { useTreeViewKeyboardNavigation } from "../internals/plugins/useTreeViewKeyboardNavigation/index.js";
import { useTreeViewLabel } from "../internals/plugins/useTreeViewLabel/index.js";
export const RICH_TREE_VIEW_PLUGINS = [useTreeViewItems, useTreeViewExpansion, useTreeViewSelection, useTreeViewFocus, useTreeViewKeyboardNavigation, useTreeViewLabel];

// We can't infer this type from the plugin, otherwise we would lose the generics.